

const LOGIN_PAGE = {
  en: {
    appName: "TA Connect",
    welcomeBack: "Welcome Back",
    loginMessage: "Login to your TA Connect account",
    usernameLabel: "Username or Email",
    usernamePlaceholder: "Enter your username or email",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter your password",
    forgotPassword: "Forgot Password?",
    loginButton: "Login",
    loggingInButton: "Logging in...",
    continueWith: "Or continue with",
    googleButton: "Continue with Google",
    noAccount: "Don't have an account?",
    registerHere: "Register here",
    registerButton: "Register",
    googleLoginError: "Failed to initiate Google login",
  },
  ar: {
    appName: "TA Connect",
    welcomeBack: "مرحباً بعودتك",
    loginMessage: "تسجيل الدخول إلى حسابك في TA Connect",
    usernameLabel: "اسم المستخدم أو البريد الإلكتروني",
    usernamePlaceholder: "أدخل اسم المستخدم أو البريد الإلكتروني",
    passwordLabel: "كلمة المرور",
    passwordPlaceholder: "أدخل كلمة المرور",
    forgotPassword: "نسيت كلمة المرور؟",
    loginButton: "تسجيل الدخول",
    loggingInButton: "جاري تسجيل الدخول...",
    continueWith: "أو تابع باستخدام",
    googleButton: "تابع باستخدام Google",
    noAccount: "ليس لديك حساب؟",
    registerHere: "سجّل هنا",
    registerButton: "تسجيل",
    googleLoginError: "فشل بدء تسجيل الدخول عبر Google",
  }
};

export default LOGIN_PAGE;
